import { GrnDtos } from "./grn-inspection.dto";

export class GrnInspectionreq {
    itemid: number;
    grnId:number;
    grndata: GrnDtos[];
    inspectedQty: number
}
export class grnIdreq {
    itemid:number;
}

export class grnReportreq {
    invoiceNo:string;
    PoId:number;
    startDate:Date
    endDate:Date
    SoNum:string;
}
export class grnReportreqsponse {
    grn:string;
    poNum:string;
    invoice:string;
    grnDate:string
    inspectionData:grnInspectionData[]
    constructor(
        grn:string,
    poNum:string,
    invoice:string,
    grnDate:string,
    inspectionData:grnInspectionData[]
    )
    {
        this.grn = grn
        this.inspectionData = inspectionData
        this.invoice = invoice
        this.poNum =poNum
        this.grnDate = grnDate
    }
}
export class grnInspectionData {
    soNum:string;
    reciedQty:number;
    pass:number;
    passWithCondition:number;
    fail:number
    insDate:string
    grnItemId:number
    itemName:string
}


